import { TableHeader } from '@tiptap/extension-table-header';

export const InlineTableHeader = TableHeader.extend({
   content: 'paragraph',
   allowGapCursor: false,

   addAttributes() {
      return {
         ...this.parent?.(),
         colwidth: {
            default: [100],
            parseHTML: element => {
               const colwidth = element.getAttribute('colwidth');
               const value = colwidth ? [parseInt(colwidth, 10)] : null;

               return value;
            },
         },
      };
   },
});
